import React from "react";
import { motion } from "framer-motion";
import { Calendar, MapPin, ArrowUpRight } from "lucide-react";

const YAALL_IMAGE =
    "https://customer-assets.emergentagent.com/job_music-tech-hub-1/artifacts/loc816dz_maajja%202025_page-0011%201.png";

export const YaallFestival = () => {
    return (
        <section
            id="yaall"
            className="relative py-28 lg:py-36 overflow-hidden"
            data-testid="yaall-section"
        >
            <div className="absolute -top-32 left-1/3 w-[500px] h-[500px] rounded-full bg-[#791EE2] opacity-15 blur-[160px] pointer-events-none" />
            <div className="absolute bottom-0 right-0 w-[450px] h-[450px] rounded-full bg-[#F54815] opacity-10 blur-[160px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 relative">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
                    {/* Copy */}
                    <motion.div
                        initial={{ opacity: 0, x: -40 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.8 }}
                        className="lg:col-span-5 order-2 lg:order-1"
                    >
                        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/15 bg-white/5 mb-6">
                            <span className="w-1.5 h-1.5 rounded-full bg-[#F54815] animate-pulse" />
                            <span className="text-[10px] uppercase tracking-[0.25em] text-white/85 font-semibold">
                                Flagship event
                            </span>
                        </div>

                        <h2
                            className="font-heading text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-extrabold tracking-tighter text-white leading-[0.95] mb-6"
                            data-testid="yaall-heading"
                        >
                            <span className="gradient-text">YAALL</span>
                            <br />
                            Global Music
                            <br />
                            Festival.
                        </h2>

                        <p className="text-lg text-white/65 max-w-md font-body leading-relaxed mb-8">
                            Maajja's premier music festival, bringing together
                            independent South Asian artists from around the
                            world for a cultural renaissance in Chennai.
                        </p>

                        <div className="flex flex-wrap gap-6 mb-10">
                            <div className="flex items-center gap-2 text-white/75">
                                <MapPin
                                    size={16}
                                    className="text-[#F54815]"
                                />
                                <span className="text-sm font-medium">
                                    Chennai · India
                                </span>
                            </div>
                            <div className="flex items-center gap-2 text-white/75">
                                <Calendar
                                    size={16}
                                    className="text-[#791EE2]"
                                />
                                <span className="text-sm font-medium">
                                    Annual · Premiere Edition 2022
                                </span>
                            </div>
                        </div>

                        <a
                            href="https://www.youtube.com/@maajja"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group inline-flex items-center gap-2 bg-[#791EE2] hover:bg-[#8b32f0] text-white px-7 py-3.5 rounded-full font-semibold transition-all hover:shadow-[0_0_40px_rgba(121,30,226,0.5)] active:scale-95"
                            data-testid="yaall-cta"
                        >
                            Watch festival highlights
                            <ArrowUpRight
                                size={18}
                                className="transition-transform group-hover:rotate-12"
                            />
                        </a>
                    </motion.div>

                    {/* Image */}
                    <motion.div
                        initial={{ opacity: 0, x: 40, scale: 0.95 }}
                        whileInView={{ opacity: 1, x: 0, scale: 1 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.9, ease: "easeOut", delay: 0.1 }}
                        className="lg:col-span-7 order-1 lg:order-2 relative"
                    >
                        <div className="relative rounded-[28px] overflow-hidden border border-white/10 bg-white">
                            <img
                                src={YAALL_IMAGE}
                                alt="YAALL Global Music Festival"
                                className="w-full h-auto block"
                                data-testid="yaall-image"
                            />
                        </div>

                        {/* Floating badge */}
                        <div className="absolute -bottom-5 left-6 lg:left-10 flex items-center gap-3 px-5 py-3 rounded-full bg-[#030023] border border-white/15 shadow-2xl">
                            <div className="flex items-end h-5 gap-[2px]">
                                {[8, 14, 10, 16, 12].map((h, i) => (
                                    <span
                                        key={i}
                                        className="w-[2px] rounded-sm eq-bar bg-[#F54815]"
                                        style={{
                                            height: `${h}px`,
                                            animationDelay: `${i * 0.12}s`,
                                        }}
                                    />
                                ))}
                            </div>
                            <span className="text-xs uppercase tracking-[0.2em] text-white font-semibold">
                                Live · Independent · Global
                            </span>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};
